import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a ResizeObserver error - these are non-critical
    if (error && error.message && error.message.includes('ResizeObserver loop')) {
      // Don't update state for ResizeObserver errors
      return null;
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Ignore ResizeObserver errors
    if (error && error.message && error.message.includes('ResizeObserver loop')) {
      console.warn('ResizeObserver loop error suppressed:', error.message);
      return;
    }
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg m-4">
          <h2 className="text-red-800 font-semibold">Something went wrong</h2>
          <p className="text-red-600 text-sm mt-2">{this.state.error?.message}</p>
          <button 
            onClick={() => this.setState({ hasError: false, error: null })}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
